export const SELECTOR_MAGIC_OFFSET = 0x217;
